import { Injectable, inject } from '@angular/core';
import { KeycloakEventTypeLegacy, KeycloakService } from 'keycloak-angular';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private keycloak = inject(KeycloakService);

  private initialized$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this.keycloak.keycloakEvents$.subscribe((event) => {
      if (event.type === KeycloakEventTypeLegacy.OnReady) {
        this.initialized$.next(true);
      }
    });
  }

  /** Observable, das true liefert, sobald Keycloak initialisiert ist */
  get isInitialized$(): Observable<boolean> {
    return this.initialized$.asObservable();
  }
}
